import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { TextField, MenuItem } from '@mui/material';
import BaseModal from 'components/BaseModal';
import CreationService from 'services/CreationService';

export const useStyles = makeStyles((theme) => ({
  input: {
    width: 230,
    maxWidth: '100%',
    textAlign: 'left',
  },
}));

const Props = {
  open: PropTypes.bool.isRequired,
  onActionClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default function CreationModal({ open, onActionClick, onClose }) {
  const classes = useStyles();
  const [folders, setFolders] = useState([]);
  const [folderId, setFolderId] = useState('');

  async function fetchFolders() {
    try {
      const response = await CreationService.findAllFolders();

      setFolders(response.data);
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    if (open) {
      fetchFolders();
    } else {
      setFolderId('');
    }
  }, [open]);

  useEffect(() => {
    if (folders.length) {
      setFolderId(folders[0].id);
    }
  }, [folders]);

  return (
    <BaseModal
      open={open}
      title={<b>Select a folder</b>}
      content={
        <TextField
          className={classes.input}
          select={true}
          variant="outlined"
          label="Folder"
          size="small"
          value={folderId}
          onChange={({ target: { value } }) => setFolderId(value)}
        >
          {folders.map((folder) => (
            <MenuItem key={folder.id} value={folder.id}>
              {folder.name}
            </MenuItem>
          ))}
        </TextField>
      }
      actionText="Add to folder"
      onActionClick={() => onActionClick(folderId)}
      onClose={onClose}
    />
  );
}

CreationModal.propTypes = Props;
